import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Cookies from 'js-cookie';
type User = {
  email: string;
  password: string;
};
const initialState = {
  loading: false,
  userInfo: undefined, // for user object
  userToken: undefined, // for storing the JWT
  error: null,
  success: false, // for monitoring the registration process.
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    onLogin: (state, action) => {
      state.userToken = action.payload.tokken;
      Cookies.set('token', action.payload.tokken);
      state.userInfo = action.payload.restOfData;
    },
    onLogOut: (state) => {
      state.userToken = undefined;
      state.userInfo = undefined;
      Cookies.remove('token');
    },
  },
});
export const onLogin = authSlice.actions.onLogin;
export const onLogOut = authSlice.actions.onLogOut;
export default authSlice.reducer;
